/** Ads hidden by default. Set `REACT_APP_SHOW_ADS=1` when backend-managed ads are ready. */
export function adsEnabled() {
  return process.env.REACT_APP_SHOW_ADS === '1';
}
